import React, { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { VoiceStatusCard } from "@/components/admin/voice/VoiceStatusCard";
import { VoiceSimulator } from "@/components/admin/voice/VoiceSimulator";
import { VoiceCalls, VoiceCallbacks, VoiceConsents, VoiceSuspicious } from "@/components/admin/voice/VoiceTables";

export default function AdminVoice() {
  const [st, setSt] = useState(null);
  const [data, setData] = useState({ calls: [], callbacks: [], consents: [], suspicious: [] });
  const [state, setState] = useState("loading");
  const load = useCallback(async () => {
    try {
      const [s, c, cb, cs, su] = await Promise.all(["/admin/voice/status", "/admin/voice/mock/calls", "/admin/voice/callbacks",
        "/admin/voice/consents", "/admin/voice/suspicious"].map((u) => api.get(u)));
      setSt(s.data); setData({ calls: c.data.items, callbacks: cb.data.items, consents: cs.data.items, suspicious: su.data.items }); setState("ok");
    } catch (e) { setState(e?.response?.status === 403 || e?.response?.status === 401 ? "denied" : "error"); }
  }, []);
  useEffect(() => { load(); }, [load]);

  if (state === "denied") return <div className="max-w-xl mx-auto p-6 text-sm" data-testid="voice-denied">Admins only.</div>;
  if (state === "error") return (
    <div className="max-w-xl mx-auto p-6 text-sm space-y-2" data-testid="voice-error">
      <div>Could not load the voice console.</div>
      <button onClick={() => { setState("loading"); load(); }} className="h-9 px-4 rounded-full border font-bold" data-testid="voice-retry">Retry</button>
    </div>
  );
  if (!st) return <div className="max-w-xl mx-auto p-6 text-sm" data-testid="voice-loading">Loading…</div>;
  return (
    <div className="max-w-5xl mx-auto px-4 pt-6 pb-32 space-y-4" data-testid="admin-voice-page">
      <div>
        <h1 className="text-2xl font-black">AINA Voice (MOCK)</h1>
        <p className="text-xs text-stone-500">Phone gateway simulator for workers, employers and providers. Everything here is simulated: no call is placed or received, nothing is recorded, and no speech or paid AI service is used.</p>
      </div>
      <div className="grid lg:grid-cols-2 gap-4">
        <VoiceStatusCard st={st} reload={load} />
        <VoiceSimulator onChange={load} />
      </div>
      <VoiceCallbacks items={data.callbacks} reload={load} />
      <div className="grid lg:grid-cols-2 gap-4">
        <VoiceConsents items={data.consents} reload={load} />
        <VoiceSuspicious items={data.suspicious} />
      </div>
      <VoiceCalls items={data.calls} />
    </div>
  );
}
